export function generateTicket (client, subject, body) {
  let link = "https://support.bearstech.com/projects/"
  link += client + "/issues/new?"
  link += encodeURI("issue[subject]=" + subject).replace('?', '%3F')
  link += encodeURI("&issue[description]=" + body).replace('?', '%3F')
  return link
}
